module.exports = __webpack_public_path__ + "static/media/photo171.5af85f56.jpg";